export default __webpack_public_path__ + "static/media/words2.ff29f105.png";